const agregatChlodzacy = { t: 'Agregat chłodzący', name: 'agregat-chlodzacy' }
export default agregatChlodzacy